import React, { Fragment } from "react";
import { Form, FormArray, FormConsumer } from "../Form";
import { TableBulkAction } from "../forms/formGrid/FormGridBulkAction";
import { FormGridInput } from "../forms/formGrid/FormGridInput";
import { useTranslation } from "../hooks/useTranslation";
import { OpacityOverlay } from "../OpacityOverlay";
import { FormStateStatus } from "../utils/FormStateStatus";
import { TableHead } from "./Table";
import { TableEmpty, TableWrapper, TD, TDAction } from "./TableComponents";
import { TableDropdown } from "./TableDropdown";
import { getCellId, getDataTestId, getItemNodeFormatting } from "./tableUtils";
export function TableForm({ form, children, id, dataId, dataTestId, dataLabel, view, }) {
    if (!form)
        return React.createElement(Fragment, null);
    const innerForm = (React.createElement("fieldset", null,
        React.createElement("legend", { className: "sr-only" }, form?.legend),
        React.createElement(FormStateStatus, { saveState: form.saveState, messages: form.messages }),
        React.createElement(OpacityOverlay, { on: form.saveState === "saving" },
            React.createElement(TableWrapper, { id: id, classNames: "table__form", dataId: dataId, dataTestId: dataTestId, dataLabel: dataLabel, view: view }, children))));
    if (!form.nestedForm)
        return React.createElement(Form, { values: form?.values ?? {} }, innerForm);
    return innerForm;
}
export function TableHeadForm({ headings, endRowColumn, form, loading, }) {
    const typedForm = form;
    const { values, name } = typedForm;
    return (React.createElement(TableHead, { headings: headings, data: [{}], endRowColumn: endRowColumn, form: form, loading: loading, tableHasData: values[name].length > 0 }));
}
export function TableBodyForm({ headings, noDataText, dropdown, id, form, loading, actions, }) {
    const t = useTranslation();
    const columnNumbers = headings.length + (dropdown ? 1 : 0);
    if (!form) {
        return React.createElement(TableEmpty, { text: noDataText, columnNumbers: columnNumbers });
    }
    if (loading) {
        return (React.createElement(TableEmpty, { text: `${t("Loading")}...`, columnNumbers: columnNumbers }));
    }
    const typedForm = form;
    const { values, name } = typedForm;
    const tableHasData = values[name].length > 0;
    if (!tableHasData) {
        return React.createElement(TableEmpty, { text: noDataText, columnNumbers: columnNumbers });
    }
    const showBulkAction = headings.some((heading) => heading.formComponent?.bulkAction);
    return (React.createElement("tbody", null,
        form.viewState === "edit" && showBulkAction && (React.createElement(TableBulkAction, { headings: headings, dropdown: dropdown, form: form })),
        React.createElement(FormArray, { name: name },
            React.createElement(FormConsumer, null, ({ values, errors, arrayIndex }) => (React.createElement("tr", null,
                headings.map((heading, i) => (React.createElement(TD, { cellId: getCellId(id, arrayIndex), hiddenBreakpoints: heading.hiddenBreakpoints, key: i, width: heading.width, dataTestId: getDataTestId(heading, arrayIndex) }, heading.formComponent ? (React.createElement(FormGridInput, { column: heading.formComponent, labelHidden: true, viewState: form.viewState, rowId: arrayIndex })) : (getItemNodeFormatting(heading, values))))),
                form.viewState === "read" && dropdown && dropdown.length && (React.createElement(TDAction, { dataId: actions?.dataId, dataLabel: actions?.dataLabel, dataTestId: actions?.dataTestId, rowId: arrayIndex },
                    React.createElement(TableDropdown, { key: "actions", item: values, dropdown: dropdown, tableId: id, rowId: arrayIndex })))))))));
}
